import React from "react";
import { Badge, BadgeColor } from "sprint-common-web";

import { NoteItem } from "../../../common/components/notes/hooks/state/NoteItem";
import { NoteSource } from "../../../common/components/notes/hooks/state/NoteSource";

export const renderNoteBadge = (noteItem: NoteItem): JSX.Element => {
    if (!noteItem.source) {
        return <></>;
    }

    const isCloud = [
        NoteSource.CloudAsset,
        NoteSource.CloudDraftAssetCloudFile,
        NoteSource.CloudDraftAssetFileRecord
    ].includes(noteItem.source);

    const text = isCloud ? "Cloud" : "On-Prem";
    const color = isCloud ? BadgeColor.LightGreen : BadgeColor.Blue;
    const testId = isCloud ? "note-cloud-badge" : "note-on-prem-badge";
    const tooltipContent = {
        [NoteSource.CloudAsset]: "Cloud asset note",
        [NoteSource.OnPremAsset]: "On-Prem asset note",
        [NoteSource.CloudDraftAssetCloudFile]: "Cloud draft asset, cloud file note",
        [NoteSource.CloudDraftAssetFileRecord]: "Cloud draft asset, associated file record note",
        [NoteSource.OnPremDraftAssetFileRecord]: "On-Prem draft asset, file record note"
    }[noteItem.source];

    return <Badge text={text} color={color} size={12} testId={testId} tooltipContent={tooltipContent} />;
};
